// 常用的封装类
import Utility from '@/assets/js/utility/Utility';
import UtilityJson from '@/assets/js/utility/UtilityJson';
import UtilitySession from '@/assets/js/utility/UtilitySession';
import UtilityString from '@/assets/js/utility/UtilityString';
import UtilityTime from '@/assets/js/utility/UtilityTime';
import UtilityUrl from '@/assets/js/utility/UtilityUrl';

// common
import CommonImagPath from '@/assets/js/common/CommonImagPath';
import CommonNodeId from '@/assets/js/common/CommonNodeId';

// 配置相关
import Config from '@/assets/js/config/Config';

// 数据相关
import Account from '@/assets/js/data/Account';
export default {
  // 常用的封装类
  _Utility: Utility,
  _UtilityJson: UtilityJson,
  _UtilitySession: UtilitySession,
  _UtilityString: UtilityString,
  _UtilityTime: UtilityTime,
  _UtilityUrl: UtilityUrl,

  // common
  _CommonImagPath: CommonImagPath,
  _CommonNodeId: CommonNodeId,
  // 配置相关
  _Config: Config,

  // 数据相关
  _Account: Account,

};
